import { useWatch } from 'react-hook-form';

import { useDinerAccount } from 'reservations/dinerAccount/hooks/useDinerAccount';
import { validateExpiration } from 'reservations/payments/helpers/validateExpiration';

export const useDinerPaymentMethods = () => {
  const date = useWatch({
    name: 'date'
  });
  const { paymentMethods, setPaymentMethods } = useDinerAccount();
  const validatedPaymentMethods = paymentMethods.map(paymentMethod => ({
    ...paymentMethod,
    isExpirationValid: validateExpiration(
      paymentMethod.cardExpMonth,
      paymentMethod.cardExpYear,
      new Date(date)
    )
  }));
  // Surface latest card
  const defaultPaymentMethod =
    validatedPaymentMethods[validatedPaymentMethods.length - 1];
  const defaultPaymentMethodId = defaultPaymentMethod?.id;

  const deletePaymentMethod = (paymentMethodToDelete: string) => {
    const updatedPaymentMethods = paymentMethods.filter(
      paymentMethod => paymentMethod.id !== paymentMethodToDelete
    );
    setPaymentMethods(updatedPaymentMethods);
  };

  return {
    defaultPaymentMethod,
    defaultPaymentMethodId,
    deletePaymentMethod,
    paymentMethods: validatedPaymentMethods,
    setPaymentMethods
  };
};
